import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=0454387c&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=0454387c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454387c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0454387c')) {
      api.createRecord('0454387c', component.options)
    } else {
      api.reload('0454387c', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=0454387c&scoped=true", function () {
      api.rerender('0454387c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/tools/rateCalculator/copponents/DataForm.vue"
export default component.exports